import { ExcelTemplateTypes, PromotionExpirationTemplateSearchTypes } from "enums";
import { useInOutTransition } from "hooks";
import SearchRadioInput from "./SearchRadioInput";

interface Props {
    searchType: string,
    updateHandler: (x: PromotionExpirationTemplateSearchTypes) => void,
    selectedTemplateType: ExcelTemplateTypes
}

export default function PromotionExpirationTemplateSearchOptions(props: Props) {
    const { searchType, updateHandler, selectedTemplateType } = props,
          shouldRender = selectedTemplateType === ExcelTemplateTypes.PromotionExpiration,
          { isActive, isNotTransitionedOut } = useInOutTransition(shouldRender, 0, 275);
    return (isNotTransitionedOut && 
        <>
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="controlNumber" 
                              labelText="Control Number" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ControlNumber}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ControlNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="promotionId" 
                              labelText="Promotion ID" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.PromotionId}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.PromotionId)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="promotionDescription" 
                              labelText="Promotion Name" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.PromotionDescription}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.PromotionDescription)} />
                              
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerId" 
                              labelText="Customer ID"
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.CustomerId}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.CustomerId)} />
            
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerName" 
                              labelText="Customer Name" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.CustomerName}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.CustomerName)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="productLineNumber" 
                              labelText="Product Line Number" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ProductLineNumber}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ProductLineNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="productLineName" 
                              labelText="Product Line Name" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ProductLineName}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ProductLineName)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="productLineCategoryNumber" 
                              labelText="Product Category Number" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ProductLineCategoryNumber}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ProductLineCategoryNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="itemNumber" 
                              labelText="Item Number" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ItemNumber}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ItemNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="itemName" 
                              labelText="Item Description" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.ItemName}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.ItemName)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="action" 
                              labelText="Action Type" 
                              checkedCondition={searchType === PromotionExpirationTemplateSearchTypes.Action}
                              onClick={() => updateHandler(PromotionExpirationTemplateSearchTypes.Action)} />
            
        </>
    );
}
